module.exports = __webpack_public_path__ + "img/doubtclass.254ca154.gif";